import { useMemo, PropsWithChildren } from 'react';
import { UserModalContent, UserModalHeader, UserModalLayout } from '@features/components/UserModalLayout';
import { AssignedOpoContactType } from '@/api/apis/case';
import { getRolesFormatted } from '@/utils/helpers';

type ContactProfileModalProps = {
  contact: AssignedOpoContactType;
};

export const OpoContactProfileModal = ({ children, contact }: ContactProfileModalProps & PropsWithChildren) => {
  const { firstName, lastName, photoPath, email, primaryPhone, secondaryPhone, parent, roles } = contact;

  const userRolesString = useMemo(() => {
    return roles.length ? getRolesFormatted(roles) : 'OPO Contact';
  }, [roles]);

  return (
    <UserModalLayout trigger={children}>
      <UserModalHeader firstName={firstName} lastName={lastName} photo={photoPath || ''} userRole={userRolesString} />
      <UserModalContent
        email={email}
        hospitalLabel="OPO"
        hospitalName={parent?.name ?? ''}
        primaryPhone={primaryPhone}
        secondaryPhone={secondaryPhone}
      />
    </UserModalLayout>
  );
};
